import React from 'react';
import { Authenticator, View } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { I18n } from 'aws-amplify';
import { translations } from '@aws-amplify/ui-react';
import { Routes, Route, NavigateFunction, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import './App.css';
import SaggitaList from './pages/SaggitaList'
import SaggitaMng from './pages/SaggitaMng'
import AccountList from './pages/AccountList'
import AccountAdd from './pages/AccountAdd'
import AccountMng from './pages/AccountMng'
import NoMatch from './pages/NoMatch';

I18n.putVocabularies(translations);
I18n.setLanguage('ja');

I18n.putVocabulariesForLanguage(
  'ja', {
    'Username': '設定アカウントID',
    'Sign in': 'ログイン',
    'Enter your Username': '設定アカウントIDを入力',
    'Incorrect username or password.': '設定アカウントIDもしくはパスワードが正しくありません'
  }
);

const components = {
  SignIn: {
    Footer() {
      return (
        <View textAlign="center">
        </View>
      );
    }
  }
}

function proc(signOut: VoidFunction, navigate: NavigateFunction) {
  signOut();
  navigate('/');
}

function App() {
  const [saggitaListLinkClass, setSaggitaListLinkClass] = React.useState('nav-item active');
  const [saggitaListLinkTextClass, setSaggitaListLinkTextClass] = React.useState('nav-link text-dark font-weight-bold');
  
  
  const [accountClass, setAccountClass] = React.useState('nav-item');
  const [accountTextClass, setaccountTextClass] = React.useState('nav-link');
  const navigate = useNavigate();

  const saggitaListLink = () => {
    setSaggitaListLinkClass('nav-item active');
    setSaggitaListLinkTextClass('nav-link text-dark font-weight-bold');

    setAccountClass('nav-item');
    setaccountTextClass('nav-link');
  }
  const accountListLink = () => {
    setSaggitaListLinkClass('nav-item');
    setSaggitaListLinkTextClass('nav-link');

    setAccountClass('nav-item active');
    setaccountTextClass('nav-link text-dark font-weight-bold');
  }
  const otherLink = () => {
    setSaggitaListLinkClass('nav-item');
    setSaggitaListLinkTextClass('nav-link');

    setAccountClass('nav-item');
    setaccountTextClass('nav-link');
  }

  return (
    <Authenticator components={components}>
      {({ signOut, user }) => (
        <div>
          <nav className="navbar navbar-expand fixed-top navbar-light admin-nab-color">
            <div className="container-fluid">
              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav mr-auto">
                  <li className={saggitaListLinkClass}>
                    <a className={saggitaListLinkTextClass} aria-current="page" href="/">通信ユニットの管理</a>
                  </li>
                  <li className={accountClass}>
                    <a className={accountTextClass} href="/account">グループの管理</a>
                  </li>
                </ul>
                <ul className="navbar-nav text-right">
                  <li className="nav-item">
                    <a className="nav-link active" href="#" onClick={() => proc(signOut!, navigate!)}>ログアウト</a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
          {/* <main className=""> */}
          <main className="flex-shrink-0 pt-5">
            {/* <div className=""> */}
            <div className="container-fluid">
              <Routes>
                <Route path="/" element={<SaggitaList signOut={signOut!} user={user!} activeLink={saggitaListLink!} />} />
                <Route path="/account" element={<AccountList activeLink={accountListLink!} />} />
                <Route path="/account/add" element={<AccountAdd activeLink={accountListLink!} />} />
                <Route path="/account/mng" element={<AccountMng activeLink={accountListLink!} />} />
                <Route path="/saggita" element={<SaggitaList signOut={signOut!} user={user!} activeLink={saggitaListLink!} />} />
                <Route path="/saggita/mng" element={<SaggitaMng activeLink={saggitaListLink!} />} />
                <Route path="*" element={<NoMatch />} />
              </Routes>
            </div>
          </main>
        </div>
      )}
    </Authenticator>
  );
}

export default App;
